/**
 * Filigree Home Decor — Theme JavaScript
 */

(function () {
  'use strict';

  /* =============================================
   * AJAX Add to Cart — intercepts all ATC forms
   * and opens the cart drawer instead of redirecting
   * ============================================= */
  function initAjaxCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function(r) {
        if (!r.ok) { return r.json().then(function(err){ throw err; }); }
        return r.json();
      })
      .then(function() {
        if (submitBtn) { submitBtn.textContent = 'Added!'; }
        setTimeout(function() {
          if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        }, 1500);
        /* Open drawer */
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
        /* Update header cart badge */
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(cart) { updateCartBadge(cart.item_count); });
      })
      .catch(function(err) {
        if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        /* Shopify rejected the add (e.g. sold out / not enough stock). Tell the
           shopper the truth instead of a fake "Added!". Fall back to the full
           cart page only on a genuine network/parse error. */
        if (err && (err.description || err.message)) {
          alert(err.description || err.message);
        } else {
          window.location.href = '/cart';
        }
      });
    });

    /* Also intercept data-atc and data-bar-atc button clicks that trigger form submit */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-bar-atc]');
      if (!btn) return;
      var form = document.querySelector('[data-product-form]');
      if (form) {
        e.preventDefault();
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  /* =============================================
   * 1. Sticky Header with scroll shadow + hero sizing
   * ============================================= */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    });

    var hero = document.querySelector('.hero');
    if (hero) {
      var heroSection = hero.closest('.shopify-section');
      if (heroSection) {
        var headerGroup = document.querySelector('.shopify-section-group-header-group');
        var headerH = headerGroup ? headerGroup.offsetHeight : 0;
        var marqueeAbove = heroSection.previousElementSibling;
        var marqueeH = marqueeAbove ? marqueeAbove.offsetHeight : 0;
        var offset = headerH + marqueeH;
        document.documentElement.style.setProperty('--hero-offset', offset + 'px');
      }
    }
  }

  /* =============================================
   * 2. Hero Slideshow
   * ============================================= */
  function initHeroSlideshow() {
    var slides = document.querySelectorAll('.hero__slide');
    if (slides.length <= 1) return;
    var current = 0;
    var speed = 4000;
    var hero = document.querySelector('[data-hero]');
    if (hero && hero.getAttribute('data-slide-speed')) speed = parseInt(hero.getAttribute('data-slide-speed'), 10) * 1000;
    setInterval(function () {
      slides[current].classList.remove('hero__slide--active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('hero__slide--active');
    }, speed);
  }

  /* =============================================
   * 3. Countdown Timer
   * ============================================= */
  function initCountdown() {
    var countdownEl = document.querySelector('[data-countdown]');
    if (!countdownEl) return;
    var days = parseInt(countdownEl.dataset.countdownDays, 10) || 7;
    var storageKey = 'filigree_countdown_end';
    var endTime = sessionStorage.getItem(storageKey);
    if (!endTime) { endTime = Date.now() + days * 24 * 60 * 60 * 1000; sessionStorage.setItem(storageKey, endTime); }
    else { endTime = parseInt(endTime, 10); }
    var daysEl = countdownEl.querySelector('[data-countdown-days-num]');
    var hoursEl = countdownEl.querySelector('[data-countdown-hours]');
    var minutesEl = countdownEl.querySelector('[data-countdown-minutes]');
    var secondsEl = countdownEl.querySelector('[data-countdown-seconds]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function update() {
      var now = Date.now(); var diff = Math.max(0, endTime - now);
      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((diff % (1000 * 60)) / 1000);
      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
      if (diff <= 0) clearInterval(timer);
    }
    update();
    var timer = setInterval(update, 1000);
  }

  function initDealsTicker() {}

  /* =============================================
   * 4. Tab switching
   * ============================================= */
  function initCollectionTabs() {
    var tabContainer = document.querySelector('[data-collection-tabs]');
    if (!tabContainer) return;
    var buttons = tabContainer.querySelectorAll('[data-tab-btn]');
    var panels = document.querySelectorAll('[data-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabId = btn.dataset.tabBtn;
        buttons.forEach(function (b) { b.classList.remove('featured-collection__tab--active'); });
        panels.forEach(function (p) { p.classList.remove('featured-collection__panel--active'); });
        btn.classList.add('featured-collection__tab--active');
        var panel = document.querySelector('[data-tab-panel="' + tabId + '"]');
        if (panel) panel.classList.add('featured-collection__panel--active');
      });
    });
  }

  /* =============================================
   * 5. Mobile Nav
   * ============================================= */
  function closeMobileNav() {
    var mobileNav = document.querySelector('[data-mobile-nav]');
    if (mobileNav) mobileNav.classList.remove('mobile-nav--open');
    document.body.classList.remove('overflow-hidden');
  }

  function initMobileNav() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    if (!mobileNav) return;
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        mobileNav.classList.toggle('mobile-nav--open');
        document.body.classList.toggle('overflow-hidden');
      });
    });
    /* 08-05: when a browser restores this exact page from its back/forward
       cache (bfcache) instead of doing a fresh load -- common on iOS Safari/
       Chrome after navigating away and back, or a backgrounded tab resuming --
       it restores the live DOM exactly as it was left, including an open menu
       and the body scroll lock. That made the menu (and whatever cart-drawer
       state was active) appear "stuck" covering the page contents. Force both
       closed whenever a page is shown from bfcache. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        closeMobileNav();
        var cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-open');
          cartDrawer.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  /* =============================================
   * 6. Scroll Animations
   * ============================================= */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('[data-animate]');
    if (!elements.length) return;
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    elements.forEach(function (el) { observer.observe(el); });
  }

  /* =============================================
   * 7. Cart Badge
   * ============================================= */
  function updateCartBadge(count) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    if (count > 0) { badge.textContent = count; badge.style.display = 'flex'; }
    else { badge.style.display = 'none'; }
  }

  /* Update badge on load */
  function initCartBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartBadge(cart.item_count); })
      .catch(function() {});
  }

  /* =============================================
   * 8. Newsletter
   * ============================================= */
  function initNewsletter() {
    var forms = document.querySelectorAll('.newsletter__form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('.newsletter__btn');
        if (btn) btn.textContent = 'Sending...';
      });
    });
  }

  function initQuantitySelectors() {
    document.addEventListener('click', function (e) {
      if (e.target.matches('[data-quantity-minus]')) {
        var input = e.target.parentElement.querySelector('[data-quantity-input]');
        var val = parseInt(input.value, 10);
        if (val > 1) { input.value = val - 1; input.dispatchEvent(new Event('change')); }
      }
      if (e.target.matches('[data-quantity-plus]')) {
        var input = e.target.parentElement.querySelector('[data-quantity-input]');
        var val = parseInt(input.value, 10);
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      }
    });
  }

  function initVariantSelectors() {
    var optionSelects = document.querySelectorAll('[data-option-index]');
    var productSelect = document.querySelector('[data-product-select]');
    if (!productSelect || optionSelects.length === 0) return;
    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var selectedOptions = [];
        optionSelects.forEach(function (s) { selectedOptions.push(s.value); });
        var options = productSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var variantData = options[i].dataset.variantJson;
          if (variantData) {
            var variant = JSON.parse(variantData);
            var match = true;
            for (var j = 0; j < selectedOptions.length; j++) {
              if (variant['option' + (j + 1)] !== selectedOptions[j]) { match = false; break; }
            }
            if (match) {
              productSelect.value = variant.id;
              var variantIdInput = document.querySelector('[data-variant-id]');
              if (variantIdInput) variantIdInput.value = variant.id;
              var submitBtn = document.querySelector('.product-page__submit');
              if (submitBtn) { submitBtn.disabled = !variant.available; submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
              var url = new URL(window.location);
              url.searchParams.set('variant', variant.id);
              window.history.replaceState({}, '', url);
              break;
            }
          }
        }
      });
    });
  }

  function initProductThumbnails() {
    var thumbs = document.querySelectorAll('.product-page__thumbnail');
    var mainImage = document.getElementById('product-main-image');
    if (!mainImage || thumbs.length === 0) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('product-page__thumbnail--active'); });
        thumb.classList.add('product-page__thumbnail--active');
        mainImage.src = thumb.dataset.imageUrl;
        mainImage.alt = thumb.dataset.imageAlt || '';
      });
    });
  }

  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-sort-by]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url;
    });
  }

  function initShareButton() {
    var shareBtn = document.querySelector('[data-share-btn]');
    if (!shareBtn) return;
    shareBtn.addEventListener('click', function () {
      if (navigator.share) { navigator.share({ title: document.title, url: window.location.href }); }
      else {
        navigator.clipboard.writeText(window.location.href).then(function () {
          shareBtn.textContent = 'Link copied!';
          setTimeout(function () { shareBtn.textContent = 'Share this product'; }, 2000);
        });
      }
    });
  }

  function initCopyButtons() {
    document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.dataset.copyTarget);
        if (target) {
          navigator.clipboard.writeText(target.value);
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = 'Copy code'; }, 2000);
        }
      });
    });
  }

  function initProductRecommendations() {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container) return;
    var productId = container.dataset.productId;
    var sectionId = container.dataset.sectionId;
    var limit = container.dataset.limit || 4;
    var url = '/recommendations/products?product_id=' + productId + '&section_id=' + sectionId + '&limit=' + limit;
    fetch(url).then(function (res) { return res.text(); }).then(function (html) {
      var temp = document.createElement('div'); temp.innerHTML = html;
      var rec = temp.querySelector('[data-product-recommendations]');
      if (rec && rec.innerHTML.trim().length) container.innerHTML = rec.innerHTML;
    });
  }

  function initCustomerLogin() {
    var recoverLink = document.getElementById('recover-link');
    var cancelRecover = document.getElementById('cancel-recover');
    var recoverForm = document.getElementById('recover-form');
    if (!recoverLink || !recoverForm) return;
    recoverLink.addEventListener('click', function (e) {
      e.preventDefault();
      recoverForm.style.display = 'block';
      recoverLink.closest('.customer-form').style.display = 'none';
    });
    if (cancelRecover) {
      cancelRecover.addEventListener('click', function (e) {
        e.preventDefault();
        recoverForm.style.display = 'none';
        recoverLink.closest('.customer-form').style.display = 'block';
      });
    }
  }

  /* =============================================
   * Initialize All
   * ============================================= */
  document.addEventListener('DOMContentLoaded', function () {
    initAjaxCart();
    initCartBadge();
    initStickyHeader();
    initHeroSlideshow();
    initCountdown();
    initDealsTicker();
    initCollectionTabs();
    initMobileNav();
    initScrollAnimations();
    initNewsletter();
    initQuantitySelectors();
    initVariantSelectors();
    initProductThumbnails();
    initCollectionSort();
    initShareButton();
    initCopyButtons();
    initProductRecommendations();
    initCustomerLogin();
  });
})();
